import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {Map, Marker, GoogleApiWrapper} from 'google-maps-react';
import './Dojo.css';
import { DojoRepository } from '../data/DojoRepository';

class BlackDragonMontreal extends Component {
  render() {
    return (
        <div class="container page-content">
            <div id="dojoHeader">
                <img id="ShotokanLogo" alt="Logo du karaté Shotokan" src="/images/logos/Shotokan.png" />
            </div>
            <article id="dojoContent">
                <section id="dojoTeam">
                    <h1>{DojoRepository.BLACK_DRAGON_MONTREAL.name}</h1>
                    <p>
                        <strong>Instructeur en chef</strong><br />
                        {DojoRepository.BLACK_DRAGON_MONTREAL.contact.gabriel.fullName}
                    </p>
                </section> 
                <p>&nbsp;</p>

                <section id="dojoContacts"> 
                    <h1>Pour nous joindre</h1>
                    <p>
                        <strong>{DojoRepository.BLACK_DRAGON_MONTREAL.name}</strong><br />
                        {DojoRepository.BLACK_DRAGON_MONTREAL.address.line1}<br />
                        {DojoRepository.BLACK_DRAGON_MONTREAL.address.city}<br />
                        {DojoRepository.BLACK_DRAGON_MONTREAL.address.postalCode}<br />
                        <a href={DojoRepository.BLACK_DRAGON_MONTREAL.links.googleMaps} target="_blank" rel="noopener noreferrer" title={DojoRepository.BLACK_DRAGON_MONTREAL.name}>Google Maps</a>
                    </p>
                    <p>
                        <strong>{DojoRepository.BLACK_DRAGON_MONTREAL.contact.gabriel.fullName}</strong><br />
                        {DojoRepository.BLACK_DRAGON_MONTREAL.contact.gabriel.phone1}<br />
                        <span class="link-like">{DojoRepository.BLACK_DRAGON_MONTREAL.contact.gabriel.email1}</span><br />
                    </p>
                </section> 
                <p>&nbsp;</p>
                
                <section id="dojo-map">
                    <Map
                        google={this.props.google}
                        initialCenter={DojoRepository.BLACK_DRAGON_MONTREAL.geo}>
                        <Marker position={DojoRepository.BLACK_DRAGON_MONTREAL.geo} />
                    </Map>
                </section> 
            </article>
            <Link class="returnToDojoRepository" to="/dojo">Retour au repertoire des Dojos</Link>
        </div>
    );
  }
}

export default GoogleApiWrapper({
    apiKey: ("AIzaSyCqdJMLfuasXIr2gfxOzJyfP1gXVQt5-H8")
})(BlackDragonMontreal)



// WEBPACK FOOTER //
// ./src/pages/dojo/BlackDragonMontreal.js